import { MenuItem, TextField, Typography, Box } from "@mui/material";
import { TimeField } from "./TimeField";

type FormQuestionPropType = {
	name: string;
	question: string;
	allowedValues?: string[];
	value: string;
	handleOnChange: (event: any) => void;
	type?: string;
	error: boolean;
	required: boolean;
	helperText?: string;
};

export const FormQuestion = (props: FormQuestionPropType) => {
	const {
		question,
		name,
		allowedValues,
		value,
		handleOnChange,
		type,
		error,
		required,
		helperText,
	} = props;

	const handleChange = (event: any, name: string) => {
		event.target.id = name;
		handleOnChange(event);
	};
	const getLabel = () => {
		if (type === "datetime-local") return;
		return name;
	};

	return (
		<Box
			sx={{
				margin: 1,

				"& .MuiTextField-root": {
					margin: 1,
					minWidth: "25ch",
					width: "100%",
				},
			}}
		>
			{question && <Typography>{question}</Typography>}
			{type === "Time" ? (
				<TimeField
					name={name}
					value={value}
					handleOnChange={(event) => handleChange(event, name)}
					required={required}
					error={error}
					helperText={error && helperText}
				/>
			) : (
				<TextField
					id={name}
					label={getLabel()}
					select={!!allowedValues}
					value={value}
					onChange={(event) => handleChange(event, name)}
					type={type}
					multiline={type === "multiline"}
					maxRows={20}
					required={required}
					error={error}
					helperText={error && helperText}
				>
					{allowedValues &&
						allowedValues.map((value) => (
							<MenuItem key={value} value={value}>
								{value}
							</MenuItem>
						))}
				</TextField>
			)}
		</Box>
	);
};
